export interface BaseOptionModel<TValue = unknown> {
    value: TValue;
    label: string;
}
